var _desc, _defs, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1000,
    height: 1000,
    viewBox: "0 0 1000 1000",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 3.5.0")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: "100%",
    height: "100%",
    fill: "rgba(255,255,255,0)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.1121 0 0 1.1247 500.009 500.0024)",
    id: 696841
  }, /*#__PURE__*/React.createElement("g", {
    style: {}
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(10.9477 0 0 10.9477 -107.4218 -0.0003)",
    id: 711494
  }, /*#__PURE__*/React.createElement("g", {
    style: {},
    vectorEffect: "non-scaling-stroke"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0 3)",
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(26,26,26)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-12, -15)",
    d: "M 18.0031376 12.5000019 c 0 -2.1514893 1.2384624 -4.0093994 3.038805 -4.9132085 c -1.6071281 -1.505188 -3.6721077 -1.586792 -4.0390015 -1.586792 c -0.9752884 0 -1.6712255 0.2641602 -2.3437204 0.5195312 c -0.651495 0.2475586 -1.2668505 0.480957 -2.1571617 0.480957 s -1.5056658 -0.2333984 -2.1571608 -0.480957 c -0.6724958 -0.2553711 -1.368433 -0.5195312 -2.3437214 -0.5195312 C 7.3867984 6.0000014 2 6.1962905 2 13.0004902 c 0 5.5639648 3.7971311 10.9995117 6.0011768 10.9995117 c 1.3493853 0 2.1254168 -0.3154297 2.8106098 -0.59375 c 0.5352612 -0.2172852 0.9982424 -0.4052734 1.6902723 -0.4052734 c 0.6920309 0 1.1550121 0.1879883 1.6902733 0.4057617 c 0.6851931 0.277832 1.4612236 0.5932617 2.8101206 0.5932617 c 1.5441265 0 3.7429676 -2.6710205 4.9975471 -6.1817627 C 19.6316776 17.2047138 18.0031376 15.0596943 18.0031376 12.5000019 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 2.5025 -9)",
    id: "XMLID_1339_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(26,26,26)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-14.5025, -3)",
    d: "M 12.0022621 6 c 2.929637 -0.5999999 5.0296059 -3.0148857 5.0003777 -6.0000014 C 14.0730009 0.5999985 11.973033 3.0148842 12.0022621 6 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -0.479 -2.4311)",
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 0.1
    },
    transform: " translate(-11.521, -9.5689)",
    d: "M 8.0011768 6.2500014 c 0.9752884 0 1.6712255 0.2641602 2.3437214 0.5195312 c 0.651495 0.2475586 1.2668495 0.480957 2.1571608 0.480957 s 1.5056667 -0.2333984 2.1571617 -0.480957 c 0.6724949 -0.2553711 1.368432 -0.5195312 2.3437204 -0.5195312 c 0.3536472 0 2.2817593 0.0888672 3.8601322 1.4424438 c 0.0608025 -0.0334473 0.1167221 -0.0744629 0.1788692 -0.1056519 c -1.6071281 -1.505188 -3.6721077 -1.586792 -4.0390015 -1.586792 c -0.9752884 0 -1.6712255 0.2641602 -2.3437204 0.5195312 c -0.651495 0.2475586 -1.2668505 0.480957 -2.1571617 0.480957 s -1.5056658 -0.2333984 -2.1571608 -0.480957 c -0.6724958 -0.2553711 -1.368433 -0.5195312 -2.3437214 -0.5195312 C 7.3867984 6.0000014 2 6.1962905 2 13.0004902 c 0 0.0458984 0.0051889 0.0914307 0.0056775 0.1372681 C 2.0681896 6.4504409 7.3904004 6.2500014 8.0011768 6.2500014 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0 6.4439)",
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 0.2
    },
    transform: " translate(-12, -18.4439)",
    d: "M 17.0024529 23.7500019 c -1.348897 0 -2.1249275 -0.3154297 -2.8101206 -0.5932617 c -0.5352612 -0.2177734 -0.9982424 -0.4057617 -1.6902733 -0.4057617 c -0.69203 0 -1.1550112 0.1879883 -1.6902723 0.4052734 c -0.6851931 0.2783203 -1.4612246 0.59375 -2.8106098 0.59375 c -2.1858535 0 -5.9337196 -5.3466797 -5.9954996 -10.8622437 C 2.005311 12.927248 2 12.9605122 2 13.0004902 c 0 5.5639648 3.7971311 10.9995117 6.0011768 10.9995117 c 1.3493853 0 2.1254168 -0.3154297 2.8106098 -0.59375 c 0.5352612 -0.2172852 0.9982424 -0.4052734 1.6902723 -0.4052734 c 0.6920309 0 1.1550121 0.1879883 1.6902733 0.4057617 c 0.6851931 0.277832 1.4612236 0.5932617 2.8101206 0.5932617 c 1.5441265 0 3.7429676 -2.6710205 4.9975471 -6.1817627 c -0.0290585 -0.0075073 -0.0553093 -0.0214233 -0.0841846 -0.0294189 C 20.6443272 21.1890278 18.5137367 23.7500019 17.0024529 23.7500019 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 2.5009 -8.8696)",
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 0.2
    },
    transform: " translate(-14.5009, -3.1303)",
    d: "M 16.9794998 0.4421892 c -0.2063999 2.7311401 -2.2307987 4.7339478 -4.9741955 5.3046875 c -0.0027466 0.0865479 -0.0038929 0.1655393 -0.0030384 0.2531247 c 2.8421106 -0.5820923 4.9035435 -2.8775632 4.9974937 -5.7393188 C 16.9910774 0.3074397 16.9943581 0.3862316 16.9794998 0.4421892 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 2.5041 -9.1329)",
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 0.1
    },
    transform: " translate(-14.5041, -2.8671)",
    d: "M 12.0053043 5.7342291 c 0.0116253 -0.0652018 0.0260839 -0.2464743 0.0404158 -0.3561025 c 0.0104027 -0.1377368 0.0253725 -0.2731414 0.044775 -0.4061723 c 0.3654556 -2.5056813 2.3033724 -4.1691899 4.9092722 -4.7112713 c 0.0027466 -0.0865479 0.0037231 -0.1730957 0.0028687 -0.2606812 C 14.1596107 0.582216 12.0980349 2.8711307 12.0053043 5.7342291 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0 0)",
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 1 0 0)",
    x1: 3.3999658,
    y1: 7.8420377,
    x2: 22.5684128,
    y2: 16.7804317
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(255,255,255)",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(255,255,255)",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "url(#SVGID_6)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-12, -12)",
    d: "M 18.0031376 12.5000019 c 0 -2.1514893 1.2384624 -4.0093994 3.038805 -4.9132085 c -1.6071281 -1.505188 -3.6721077 -1.586792 -4.0390015 -1.586792 c -0.9752884 0 -1.6712255 0.2641602 -2.3437204 0.5195312 c -0.651495 0.2475586 -1.2668505 0.480957 -2.1571617 0.480957 s -1.5056658 -0.2333984 -2.1571608 -0.480957 c -0.6724958 -0.2553711 -1.368433 -0.5195312 -2.3437214 -0.5195312 C 7.3867984 6.0000014 2 6.1962905 2 13.0004902 c 0 5.5639648 3.7971311 10.9995117 6.0011768 10.9995117 c 1.3493853 0 2.1254168 -0.3154297 2.8106098 -0.59375 c 0.5352612 -0.2172852 0.9982424 -0.4052734 1.6902723 -0.4052734 c 0.6920309 0 1.1550121 0.1879883 1.6902733 0.4057617 c 0.6851931 0.277832 1.4612236 0.5932617 2.8101206 0.5932617 c 1.5441265 0 3.7429676 -2.6710205 4.9975471 -6.1817627 C 19.6316776 17.2047138 18.0031376 15.0596943 18.0031376 12.5000019 z M 17.002636 0.0000017 c -2.9296513 0.5999756 -5.0296116 3.0148926 -5.00037 6 C 14.9319181 5.3999648 17.0318775 2.9851091 17.002636 0.0000017 z",
    strokeLinecap: "round"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.0666 0 0 3.9733 123.5033 18.7269)",
    id: 558630
  }, /*#__PURE__*/React.createElement("g", {
    style: {},
    vectorEffect: "non-scaling-stroke"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.584 0 0 0.584 -5.0833 1.4678)",
    id: "path10079_1_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(477.1, 166.7923)",
    d: "M -477.1 -189.5 c -3.4 0 -6.3 0.7 -9.1 2.1 c -7.3 3.6 -11.5 11.3 -11.5 20.9 c 0 9.6 4.1 17.1 11.4 20.5 c 2 0.9 4 1.4 7 1.8 c 1.5 0.1 2.9 0.2 4.4 0 c 3 -0.4 5 -0.9 7 -1.8 c 7.3 -3.5 11.4 -10.9 11.4 -20.5 c 0 -9.6 -4.2 -17.3 -11.5 -20.9 C -470.9 -188.8 -473.8 -189.5 -477.1 -189.5 L -477.1 -189.5 z M -474.2 -182.7 c 4.4 1.2 7.5 5.1 8.8 10.9 c 0.9 4 0.6 8.7 -0.6 12.4 c -1.9 5.7 -6 9 -11.1 8.9 c -5 0.1 -9.2 -3.2 -11.1 -8.9 c -1.2 -3.7 -1.5 -8.3 -0.6 -12.4 c 1.2 -5.8 4.4 -9.7 8.8 -10.9 C -478.1 -183.1 -476.1 -183.1 -474.2 -182.7 L -474.2 -182.7 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.584 0 0 0.584 -22.0774 1.4633)",
    id: "path10077_1_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(506.2, 166.8)",
    d: "M -506.2 -189.5 c -2.4 0 -4.4 2 -4.4 4.4 c 0 2.4 2 4.4 4.4 4.4 s 4.4 -2 4.4 -4.4 C -501.8 -187.5 -503.8 -189.5 -506.2 -189.5 z M -510.3 -176.2 v 32.1 h 8.2 v -32.1 H -510.3 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.584 0 0 0.584 16.4945 1.4967)",
    id: "path10039_1_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(440.15, 166.7429)",
    d: "M -444.7 -144.1 c -3.5 -0.6 -6.9 -1.1 -9.7 -2.7 c 0 0 1.7 -6.5 1.8 -6.6 c 4.6 1.6 11.1 3.7 15.4 1.7 c 2.4 -1.2 3.5 -3.4 3.2 -5.9 c -0.4 -2.9 -2.4 -4.5 -7.8 -6.5 c -6 -2.3 -9.6 -5 -11 -8.6 c -0.7 -1.8 -0.9 -4 -0.6 -6 c 0.9 -5.5 5.2 -9.3 11.7 -10.5 c 1.9 -0.3 6 -0.3 8 0 c 2.9 0.5 6.2 1.6 6.2 2 c 0 0.2 -1.7 6.1 -1.8 6.3 c -2.9 -1.1 -6 -1.9 -8.8 -2 c -3.8 -0.1 -8 2.2 -7.3 6.2 c 0.5 2.5 2.1 3.7 8 6.1 c 4.4 1.8 6.4 3 8.2 4.8 c 2.5 2.5 3.3 5.4 3.3 8.3 c 0 2.4 -0.2 3.5 -1.1 5.4 c -2.1 4.5 -6.3 7.1 -12.7 7.8 C -440.9 -144.1 -443.7 -144 -444.7 -144.1 L -444.7 -144.1 z",
    strokeLinecap: "round"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIos);
export default __webpack_public_path__ + "static/media/ios.9ee688380397fec6b4fcb13947de6224.svg";
export { ForwardRef as ReactComponent };